import { useMutation } from "@tanstack/react-query"
import { useSearchParams } from "react-router-dom"
import axios from "axios"
import { QUERY_PARAMS_EXCHANGE_TOKEN_KEY } from "../../../utils/constants"
import { IRegistrationOtpResponse } from "./interface"

const API_REGISTRATION_OTP_URL = `${window.extended.REACT_APP_API_URL}/api/registration-2/otp`

const resendRegistrationOtp = async (exchangeToken: string | null) => {
  const response = await axios.post(API_REGISTRATION_OTP_URL, null, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${exchangeToken}`,
    },
  })
  return response.data
}

export const useResendRegistrationOtp = () => {
  const [searchParams] = useSearchParams()
  const exchangeToken = searchParams.get(QUERY_PARAMS_EXCHANGE_TOKEN_KEY)

  return useMutation<IRegistrationOtpResponse, void>({
    mutationFn: () => resendRegistrationOtp(exchangeToken),
    retry: false,
  })
}
